import { render, staticRenderFns } from "./EnterPhoneNumber.vue?vue&type=template&id=90f2333a&scoped=true"
import script from "./EnterPhoneNumber.vue?vue&type=script&lang=js"
export * from "./EnterPhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./EnterPhoneNumber.vue?vue&type=style&index=0&id=90f2333a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f2333a",
  null
  
)

export default component.exports